import { Pencil, Trash2, MessageCircle, Instagram, ExternalLink } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { CHANNEL_LABEL } from "@/components/autoreplies/AutoReplyForm";

const ChannelIcons = ({ channel }) => (
  <span className="flex items-center gap-1 text-[#6B6157]">
    {channel !== "instagram" && <MessageCircle className="h-3.5 w-3.5 text-[#25D366]" />}
    {channel !== "whatsapp" && <Instagram className="h-3.5 w-3.5 text-[#C13584]" />}
    <span className="text-xs">{CHANNEL_LABEL[channel]}</span>
  </span>
);

export const AutoReplyRow = ({ item, onEdit, onDelete, onToggle, toggling }) => (
  <div data-testid={`auto-reply-item-${item.keywords[0]}`} className={`flex flex-wrap sm:flex-nowrap items-start gap-4 px-5 py-4 transition-opacity ${item.active ? "" : "opacity-60"}`}>
    <div className="min-w-0 flex-1">
      <div className="flex flex-wrap items-center gap-2 mb-1.5">
        {item.keywords.map((k) => (
          <code key={k} data-testid="auto-reply-keyword" className="text-sm font-semibold rounded-md bg-[#F1EBE1] text-[#1A1A1A] px-2 py-0.5">{k}</code>
        ))}
        <ChannelIcons channel={item.channel} />
        <span data-testid="auto-reply-status" className={`text-[11px] font-medium rounded-full border px-2 py-0.5 ${item.active ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-[#F4F2EE] text-[#8A7E70] border-[#E7E2DA]"}`}>
          {item.active ? "Activo" : "Inactivo"}
        </span>
      </div>
      <p className="text-sm text-[#4A4239] whitespace-pre-wrap line-clamp-3">{item.response}</p>
      {item.button_label && item.button_url && (
        <a data-testid="auto-reply-link-button" href={item.button_url} target="_blank" rel="noopener noreferrer" title={item.button_url}
          className="mt-2 inline-flex items-center gap-1.5 rounded-full border border-[#E0D3BC] bg-[#FAF8F5] hover:bg-[#F1EBE1] px-3 py-1 text-xs font-semibold text-[#1A1A1A] transition-colors">
          <ExternalLink className="h-3.5 w-3.5" /> {item.button_label}
        </a>
      )}
      <p className="text-[11px] text-[#A79E90] mt-1.5">Usada {item.hits} {item.hits === 1 ? "vez" : "veces"}</p>
    </div>
    <div className="flex items-center gap-1.5 shrink-0">
      <Switch data-testid="auto-reply-toggle" checked={item.active} disabled={toggling} onCheckedChange={(v) => onToggle(item, v)} title={item.active ? "Desactivar" : "Activar"} />
      <button data-testid="auto-reply-edit-btn" onClick={() => onEdit(item)} title="Editar" className="h-8 w-8 rounded-full flex items-center justify-center text-[#6B6157] hover:bg-[#F1EBE1] transition-colors">
        <Pencil className="h-4 w-4" />
      </button>
      <button data-testid="auto-reply-delete-btn" onClick={() => onDelete(item)} title="Eliminar" className="h-8 w-8 rounded-full flex items-center justify-center text-[#A79E90] hover:bg-red-50 hover:text-red-600 transition-colors">
        <Trash2 className="h-4 w-4" />
      </button>
    </div>
  </div>
);
